import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDirectReferralAction } from "../../../redux/actions/referrals";
import useCommonParams from "../../../hooks/useCommonParams";

export default function useGetDirectReferallsQuery(enabled = true) {
  const dispatch = useDispatch();

  const { DirectReferrals, isDirectLoading, totalDirectRecords } = useSelector(
    (state) => state.referrals
  );

  const { queryParams } = useCommonParams();

  useEffect(() => {
    if (enabled) {
      dispatch(getDirectReferralAction(queryParams));
    }
  }, [queryParams, enabled]);

  return {
    DirectReferrals,
    totalDirectRecords,
    isDirectLoading,
  };
}
